export default "__VITE_ASSET__Ad8qeeN___"